import { render, staticRenderFns } from "./driver_actuals_booking_panel.vue?vue&type=template&id=2b948e46&scoped=true&"
import script from "./driver_actuals_booking_panel.vue?vue&type=script&lang=js&"
export * from "./driver_actuals_booking_panel.vue?vue&type=script&lang=js&"
import style0 from "./driver_actuals_booking_panel.vue?vue&type=style&index=0&id=2b948e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b948e46",
  null
  
)

export default component.exports